import type { WizardStep } from '../types'

export const WIZARD_STEPS: { step: WizardStep; titleKey: string; hintKey: string }[] = [
  { step: 1, titleKey: 'hr.belgeler.wizard.steps.info', hintKey: 'hr.belgeler.wizard.hints.info' },
  { step: 2, titleKey: 'hr.belgeler.wizard.steps.fields', hintKey: 'hr.belgeler.wizard.hints.fields' },
  { step: 3, titleKey: 'hr.belgeler.wizard.steps.preview', hintKey: 'hr.belgeler.wizard.hints.preview' },
  { step: 4, titleKey: 'hr.belgeler.wizard.steps.publish', hintKey: 'hr.belgeler.wizard.hints.publish' },
]
